/**
 * In-progress exam state (sessionStorage, same tab). Lets the 1h deadline survive refresh;
 * cleared on submit, expiry, or completed attempt restore.
 */
const PREFIX = 'certpro_exam_draft_v1_'

/**
 * @typedef {{ version: 1, deadlineMs: number, answers: Record<string, unknown>, index: number }} CertificationExamDraft
 */

/**
 * @param {string} trackId
 * @param {Omit<CertificationExamDraft, 'version'>} payload
 */
export function saveExamDraft(trackId, payload) {
  if (!trackId) return
  try {
    const draft = { version: 1, ...payload }
    window.sessionStorage.setItem(`${PREFIX}${trackId}`, JSON.stringify(draft))
  } catch {
    // ignore quota / private mode
  }
}

/**
 * @param {string} trackId
 * @returns {CertificationExamDraft | null}
 */
export function loadExamDraft(trackId) {
  if (!trackId) return null
  try {
    const raw = window.sessionStorage.getItem(`${PREFIX}${trackId}`)
    if (!raw) return null
    const data = JSON.parse(raw)
    if (data?.version !== 1 || typeof data.deadlineMs !== 'number') return null
    if (data.deadlineMs <= Date.now()) {
      clearExamDraft(trackId)
      return null
    }
    if (typeof data.answers !== 'object' || data.answers === null) return null
    if (typeof data.index !== 'number' || data.index < 0) return null
    return data
  } catch {
    return null
  }
}

/** @param {string} trackId */
export function clearExamDraft(trackId) {
  if (!trackId) return
  try {
    window.sessionStorage.removeItem(`${PREFIX}${trackId}`)
  } catch {
    // ignore
  }
}
